export default "__VITE_ASSET__LYSU0dLH__"